export interface SavedQuery {
  id: string;
  name: string;
  sql: string;
  createdAt: string;
  updatedAt: string;
}

const STORAGE_KEY = "linabase:saved-queries";

function readAll(): SavedQuery[] {
  if (typeof window === "undefined") return [];
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function writeAll(queries: SavedQuery[]) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(queries));
}

export function getSavedQueries(): SavedQuery[] {
  return readAll().sort(
    (a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime(),
  );
}

export function saveQuery(name: string, sql: string): SavedQuery {
  const queries = readAll();
  const now = new Date().toISOString();
  const query: SavedQuery = {
    id: crypto.randomUUID(),
    name,
    sql,
    createdAt: now,
    updatedAt: now,
  };
  queries.push(query);
  writeAll(queries);
  return query;
}

export function updateQuery(
  id: string,
  updates: Partial<Pick<SavedQuery, "name" | "sql">>,
): SavedQuery | null {
  const queries = readAll();
  const idx = queries.findIndex((q) => q.id === id);
  if (idx === -1) return null;
  if (updates.name !== undefined) queries[idx].name = updates.name;
  if (updates.sql !== undefined) queries[idx].sql = updates.sql;
  queries[idx].updatedAt = new Date().toISOString();
  writeAll(queries);
  return queries[idx];
}

export function deleteQuery(id: string): void {
  const queries = readAll().filter((q) => q.id !== id);
  writeAll(queries);
}
